import React, { useEffect } from "react";
import { LOGO_ALEATICA_CRASH } from "../../constants/images";
import classes from "./ErrorBoundary.module.scss";
// import { useTranslation } from "react-i18next";
import platform from "platform";
import packageJson from "../../../package.json";

const ErrorBoundaryFallbackComponent = ({ error, info }) => {
  // const { t } = useTranslation();
  useEffect(() => {
    const winLocation = window.location;
    if (
      winLocation &&
      winLocation.hostname &&
      winLocation.hostname === "localhost"
    ) {
      console.error("Error local no mandamos reporte");
    } else {
      let report = {
        // userId: user.getId(), //lo pone el servidor
        stackInfo: JSON.stringify(info),
        stackError: JSON.stringify(error, Object.getOwnPropertyNames(error)),
        browser: platform.description,
        os: platform.os.toString(),
        level: "error",
        app: packageJson.name,
        environment: packageJson.environment,
        version: packageJson.version
      };
      // sendCrashReport(report);
    }
  }, []);
  return (
    <div
      className={[
        classes.errorContainer,
        "d-flex align-items-center justify-content-center flex-column"
      ].join(" ")}
    >
      <img src={LOGO_ALEATICA_CRASH} alt="" />
      <h1>Oops!</h1>
      {/* <h6 className="text-center">{t("errors.contactAdminError")}</h6> */}
    </div>
  );
};

export default ErrorBoundaryFallbackComponent;
